import React from "react";
import { Progress, InfiniteScroll, dialog, Button } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import Table from "../../../../components/Table";
import NominationRequestPresenter from "./NominationRequestPresenter";
import Queue from "nq";

class NominationRequest extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new NominationRequestPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "nomination_request";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async handleApproveData(data) {
    const query = {
      where: {
        id: data.id,
      },
      include: ["employee", "username"],
    };
    const approveNomi = await findObjectUseCase().execute(
      "nomination_request",
      query
    );
    for (const nomi of approveNomi) {
      const { id, ...newNomi } = nomi;
      const newData = { stats: "Approved", ...newNomi };
      await upsertUseCase().execute("approve_nomination", newData);
      // await deleteObjectUseCase().execute("nomination_request", nomi.id);
      await new Queue.Document().delete("nomination_request", nomi.id);
      this.showSuccess("Data successfully APPROVED!");
      return this.refetchData();
    }
  }

  async handleDisapproveData(id) {
    try {
      dialog.fire({
        html: (
          <div className="p-2">
            <h4>Disapprove</h4>
            <hr />
            <p style={{ margin: "2rem 0" }}>
              Are you sure you want to DISAPPROVE?
            </p>
            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3">
              <Button
                className="btn btn-light fs-sm"
                onClick={() => dialog.close()}
              >
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  // await deleteObjectUseCase().execute("nomination_request", id);
                  await new Queue.Document().delete("nomination_request", id);
                  dialog.close();
                  this.showSuccess("Data successfully DISAPPROVED!");
                  return this.refetchData();
                }}
                className="btn btn-primary"
              >
                Confirm
              </Button>
            </div>
          </div>
        ),
        footer: false,
      });
    } catch (error) {
      console.error("Error handling disapprove data: ", error);
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    console.log("obb :", objects);
    // const empPointer = objects
    //   .filter((item) => typeof item.employee === "object")
    //   .map((item) => item.employee);

    if (!schema) return <Progress />;
    return (
      <>
        <div>
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-block">
                  <h4 className="text-primary">Recognition Request</h4>
                </div>
              </CardView>

              <Table
                // empPointer={empPointer}
                progress={loading}
                objectData={this.handleApproveData.bind(this)}
                objectId={this.handleDisapproveData.bind(this)}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: (
                      <b>
                        <i className="bi bi-search"> Approve</i>
                      </b>
                    ),
                    actionType: "object",
                  },
                  {
                    label: (
                      <b>
                        <i className="bi bi-pencil-square"> Disapprove</i>
                      </b>
                    ),
                    actionType: "delete",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(NominationRequest);
